import {
  CoreBankingCustomerData,
  CoreBankingRawPayload,
} from "../entities/Customers";

export interface ApiCoreBankingCustomerItem {
  id: string;
  businessKey?: string;
  customerCode?: string;
  code_client?: string | null;
  codeClient?: string | null;
  first_name?: string;
  last_name?: string;
  full_name?: string;
  gender?: string | null;
  genre?: string | null;
  email?: string | null;
  phone1CountryCode?: string | null;
  phone1?: string | null;
  telephone?: string | null;
  riskLevel?: string | null;
  status?: string | null;
  advisorName?: string | null;
  advisor?: {
    firstName?: string | null;
    lastName?: string | null;
  } | null;
  nationality?: {
    code?: string | null;
    name?: string | null;
  } | null;
  nationalite?: string | null;
  language?: {
    code?: string | null;
    name?: string | null;
  } | null;
  legalCapacity?: {
    code?: string | null;
    name?: string | null;
  } | null;
  familyStatus?: {
    code?: string | null;
    name?: string | null;
  } | null;
  family_status?: {
    code?: string | null;
    name?: string | null;
  } | null;
  legalSituation?: {
    code?: string | null;
    name?: string | null;
  } | null;
  address?: {
    street?: string | null;
    area?: string | null;
    city?: string | null;
    postalCode?: string | null;
    countryName?: string | null;
  } | null;
  accountNumber?: string | null;
  account_number?: string | null;
  nom?: string | null;
  adresse?: string | null;
  codePostal?: string | null;
  code_postal?: string | null;
  nbr_compte?: string | number | null;
}

export class CoreBankingCustomersMapper {
  static toDomainItem(
    item: ApiCoreBankingCustomerItem
  ): CoreBankingCustomerData {
    const buildFullName = () => {
      if (item.nom) {
        return item.nom;
      }
      const parts = [item.first_name, item.last_name].filter(Boolean);
      if (parts.length) {
        return parts.join(" ").trim();
      }
      return item.full_name ?? "";
    };

    const advisorName = item.advisor
      ? [item.advisor.firstName, item.advisor.lastName]
        .filter((value) => !!value && value.trim().length > 0)
        .join(" ")
        .trim()
      : null;

    const formatAddress = () => {
      if (!item.address) {
        return item.adresse ?? null;
      }
      const { street, area, city, countryName } = item.address;
      const segments = [street, area, city, countryName]
        .filter((value) => !!value && value.trim().length > 0)
        .map((value) => value?.trim());
      if (segments.length === 0) {
        return null;
      }
      return segments.join(", ");
    };

    return {
      id: item.id,
      customerCode:
        item.codeClient ??
        item.code_client ??
        item.customerCode ??
        item.businessKey ??
        item.id,
      email: item.email ?? "",
      nom: buildFullName(),
      genre: item.genre ?? item.gender ?? null,
      nationalite: item.nationalite ?? item.nationality?.name ?? null,
      statutMarital:
        item.familyStatus?.name ??
        item.family_status?.name ??
        null,
      adresse: formatAddress(),
      codePostal:
        item.codePostal ?? item.code_postal ?? item.address?.postalCode ?? null,
      telephone: item.phone1CountryCode ? `${item.phone1CountryCode + item.phone1}` : item.phone1 ?? null,
      accountNumber:
        item.accountNumber ??
        item.account_number ??
        (item.nbr_compte !== undefined && item.nbr_compte !== null
          ? String(item.nbr_compte)
          : item.customerCode ?? ""),
      advisorName: advisorName || item.advisorName || null,
      status: item.status ?? null,
      riskLevel: item.riskLevel ?? null,
      rawPayload: item as CoreBankingRawPayload,
    };
  }

  static toDomainItems(
    items: ApiCoreBankingCustomerItem[]
  ): CoreBankingCustomerData[] {
    return items.map((item) => this.toDomainItem(item));
  }
}
